module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="prompt-box">\r\n    <div class="prompt-head">\r\n        <h6 class="prompt-title">温馨提示</h6>\r\n    </div>\r\n\r\n    <div class="prompt-content">为避免账户信息泄露， 建议您前往个人中心修改初始密码</div>\r\n\r\n    <button class="jump-btn">\r\n        <a href="/myinfo/toMyInfoHome.do?resetPassword=true">立即修改</a>\r\n    </button>\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/customizePrompt/templates/prompt.ejs
// module id = 16
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 14 15 16 17 18 19 20 21 22 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46